import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editSite } from 'action/site'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import SiteForm from 'view/page/site-management/component/site-form'
import FormModal from 'view/component/form-modal'
import confirmModalDifferences from 'view/component/confirm-modal-differences'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'Site edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const generateModalText = () => ({
  decide: {
    content: 'This action cannot be undone',
    title: 'Are you sure you want to edit the following fields?'
  }
})

const getSiteDifferences = (initialValues, editedValues) => {
  const differences = {}
  const values = _.omit(initialValues, [
    'special',
    'pl_admin_ad_group_uuid',
    'pl_default_uuid',
    'pl_general_ad_group_uuid',
    'pl_super_ad_group_uuid'
  ])
  const objectKeys = Object.keys(values)
  objectKeys.forEach(key => {
    if (values[key] !== editedValues[key]) {
      differences[key] = editedValues[key]
    }
  })
  return differences
}

const validateForm = (site, form, decide, handleConfirm) => {
  form.validateFields().then((values) => {
    const { created, modified, published, uuid, ...initialValues } = site
    const differences = getSiteDifferences(initialValues, values)
    confirmModalDifferences(() => handleConfirm(values), decide, differences)
  }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
}

const EditSite = ({ site, editSite, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const { decide } = generateModalText()

  const handleClick = () => {
    setVisible(true)
  }

  const handleConfirm = async (values) => {
    const response = await editSite({ ...values, uuid: site.uuid })
    setVisible(false)
    !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
  }

  const handleSubmit = () => validateForm(site, form, decide, handleConfirm)

  return (
    <>
      <a onClick={handleClick}>Edit Site</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(site)
        }}
        title='Edit Site'
        visible={visible}
      >
        <SiteForm
          form={form}
          site={site}
        />
      </FormModal>
    </>
  )
}

EditSite.propTypes = {
  editSite: PropTypes.func,
  site: PropTypes.object,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.siteSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editSite: bindActionCreators(editSite, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditSite)
